import { createScopedProfile } from './omneoProfileScope.mjs'
import { defaultCreateClient } from './omneoClientFactory.js'
import { wishlistItemBody } from './wishlistItemBody.mjs'

/**
 * Wishlist writes against one child profile. Each call builds its own SDK client, so
 * Connection()'s endpoint rewrite cannot leak into anything else on the page.
 */
export const createScopedWishlistWriter = (connectionId) => {
  const profile = createScopedProfile(connectionId, defaultCreateClient)

  return {
    updateWishlistItem: (listId, listItemId, body) => profile.updateListItem(listId, listItemId, body),
    addWishlistItem: (listId, sku, meta, quantity) =>
      profile.createListItem(listId, wishlistItemBody(sku, meta, quantity)),
    removeWishlistItem: (listId, itemId) => profile.deleteListItem(listId, itemId)
  }
}
